

@if (!orderId) {
  @if (!onlineOrder) {
    <app-cart [isCheckout]="true"></app-cart>
  }
  @if (onlineOrder) {
    <app-cart [isCheckout]="true" [orderNumber]="onlineOrder.id" [order]="onlineOrder"></app-cart>
  }
  <div class="ct-container">
    <div class="ct-main-content">
      @if (checkout) {
        <div class="checkout">
          <div class="delivery-fee">ENTREGA: &nbsp;&nbsp;&nbsp; {{(checkout.delivery_fee | currency:'BRL':'').replace('.',',')}}</div>
          <div class="total">TOTAL: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{checkout.prettyTotal}}</div>
          <hr/>
          @if (customer) {
            <div class="delivery-info">
              <table>
                <tbody>
                  <tr>
                    <td>Bairro:</td>
                    <td>{{customer.district}}</td>
                  </tr>
                  <tr>
                    <td>Contato:</td>
                    <td>{{customer.phone}}</td>
                  </tr>
                  <tr>
                    <td>Endereço:</td>
                    <td>{{customer.address}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
          <hr/>
          @if (customer.coords) {
            <div>
              <i>Por favor, confira novamente sua localização. Caso esteja incorreta, por favor clique <a href="#" (click)="goToCustomerDetails($event)">AQUI</a>.</i>
              @if (geoposition) {
                <agm-map [latitude]="geoposition.latitude" [longitude]="geoposition.longitude"
                  [mapTypeId]="mapOptions.mapType" [zoom]="mapOptions.zoom"
                  [clickableIcons]="mapOptions.clickableIcons" class="google-maps">
                  <agm-marker [latitude]="geoposition.latitude" [longitude]="geoposition.longitude"></agm-marker>
                </agm-map>
              }
              <hr/>
            </div>
          }
          <div class="payment">
            <div class="payment-type">
              <label for="pag" class="field-label">Forma de pagamento*</label>
              <select id="pag" class="form-control" [disabled]="onlineOrder" [(ngModel)]="checkout.paymentType" (change)="checkPix()">
                <option value="">Selecione</option>
                <option [disabled]="paymentRestriction.indexOf('credit_card') >= 0" value="credit">
                  Cartão de crédito {{paymentRestriction.indexOf('credit_card') >= 0 ? '(Indisponível)' : ''}}
                </option>
                <option [disabled]="paymentRestriction.indexOf('debit_card') >= 0" value="debit">
                  Cartão de débito {{paymentRestriction.indexOf('debit_card') >= 0 ? '(Indisponível)' : ''}}
                </option>
                <option [disabled]="paymentRestriction.indexOf('cash') >= 0" value="cash">
                  Dinheiro {{paymentRestriction.indexOf('cash') >= 0 ? '(Indisponível)' : ''}}
                </option>
                <option [disabled]="paymentRestriction.indexOf('transfer') >= 0" value="transfer">
                  Transferência {{paymentRestriction.indexOf('transfer') >= 0 ? '(Indisponível)' : '(contatar estabelecimento)'}}
                </option>
                <option [disabled]="paymentRestriction.indexOf('pix') >= 0" value="pix">
                  PIX {{paymentRestriction.indexOf('pix') >= 0 ? '(Indisponível)' : '(contatar estabelecimento)'}}
                </option>
              </select>
            </div>
            <!-- Pix payment -->
            @if (checkout.paymentType == 'pix' || checkout.paymentType == 'transfer') {
              <div class="change">
                <!-- No pix info -->
                @if (!pixCopiaCola) {
                  <label class="field-label">Após realizar o pedido, entre em contato com o estabelecimento para conseguir os dados para pagamento :)</label>
                }
                <!-- Has pix info -->
                @if (pixCopiaCola) {
                  <div>
                    <label class="field-label" for="pix-copia-cola">Para sua comodidade, geramos o PIX Copia-e-Cola</label>
                    <textarea id="pix-copia-cola" readonly class="field-label">{{pixCopiaCola}}</textarea>
                    <button class="btn btn-md btn-primary copiar-pix" (click)="copyPixCopiaCola()">
                      @if (!pixCopied) {
                        <span>Copiar</span>
                      }
                      @if (pixCopied) {
                        <span>
                          Copiado! <fa-icon [icon]="faCheck"></fa-icon>
                        </span>
                      }
                    </button>
                  </div>
                }
              </div>
            }
            <!-- Cash payment -->
            @if (checkout.paymentType == 'cash') {
              <div class="change">
                <label for="pag" class="field-label">
                  Precisa de troco?
                  <span class="need-change">
                    <input type="radio" name="needChange1" id="ineed" [value]="trueVal" [(ngModel)]="needChange"/>
                    <label for="ineed">SIM</label> &nbsp;
                    <input type="radio" name="needChange1" id="idontneed" [value]="falseVal" [(ngModel)]="needChange"/>
                    <label for="idontneed">NÃO</label>
                    <br/>
                    @if (needChange) {
                      <div>
                        Troco para:
                      </div>
                    }
                  </span>
                </label>
                @if (errorMsgs['change']) {
                  <label for="nchange" class="error-label">{{errorMsgs['change']}}</label>
                }
                @if (needChange) {
                  <input id="nchange" type="text" class="form-control" [readonly]="onlineOrder" [(ngModel)]="checkout.changeNeeded" mask="0*" />
                }
              </div>
            }
          </div>
          @if (!onlineOrder) {
            <div class="actions">
              <button (click)="goBack()" class="btn btn-lg btn-secondary back-button">Voltar</button>
              <button id="concluir" (click)="placeOrder()" [disabled]="!checkout.paymentType || sending" class="btn btn-lg btn-success">
                @if (!sending) {
                  <span class="blink-me">
                    CONCLUIR
                  </span>
                }
                @if (sending) {
                  <fa-icon [icon]="faSpinner" [spin]="true"></fa-icon>
                }
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
@else {
  <div class="reservation-details">
    <div class="success-text">PEDIDO REALIZADO COM SUCESSO!</div>
    <div class="success-buttons">
      <button class="btn btn-lg btn-success" (click)="openWapp()">
        <fa-icon [icon]="faWhatsapp" size="lg"></fa-icon> ACOMPANHAR PEDIDO
      </button>
      <br/>
      <br/>
      <button class="btn btn-lg btn-secondary" (click)="dontOpenWapp()">
        <small>não receber informações</small>
      </button>
    </div>
  </div>
}